import { useMemo } from "react";

import useNoSubmit from "./useNoSubmit";
import usePartialSubmit, { PartialSubmitOptions } from "./usePartialSubmit";

type MaybeSubmitOptions = PartialSubmitOptions & { shouldSubmit: boolean };

const useMaybeSubmit = ({ shouldSubmit, ...rest }: MaybeSubmitOptions) => {
  const partialSubmitResult = usePartialSubmit(rest);
  const noSubmitResult = useNoSubmit(rest);
  const handleNext = useMemo(
    () => (shouldSubmit ? partialSubmitResult.handleNext : noSubmitResult.handleNext),
    [shouldSubmit, partialSubmitResult.handleNext, noSubmitResult.handleNext]
  );
  const submitHandler = useMemo(
    () => (shouldSubmit ? partialSubmitResult.submitHandler : noSubmitResult.submitHandler),
    [shouldSubmit, partialSubmitResult.submitHandler, noSubmitResult.submitHandler]
  );
  const nextDisabled = useMemo(
    () => (shouldSubmit ? partialSubmitResult.nextDisabled : noSubmitResult.nextDisabled),
    [shouldSubmit, partialSubmitResult.nextDisabled, noSubmitResult.nextDisabled]
  );
  const nextLoading = useMemo(
    () => (shouldSubmit ? partialSubmitResult.nextLoading : false),
    [shouldSubmit, partialSubmitResult.nextLoading]
  );
  return { handleNext, submitHandler, nextDisabled, nextLoading };
};

export default useMaybeSubmit;
